import React from 'react';
import { MessageCircle, Mail, MapPin, Store } from 'lucide-react';

const GOLD = '#C9A84C';

const ANGEL_PHOTO =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/cdd343056fb6a35b_WhatsApp%20Image%202026-10-09%20at%2010.49.09%20AM.jpeg';

const sucursales = [
  {
    nombre: 'Colectivo Punto Este',
    tipo: 'Colectivo Comercial',
    referencia: 'Plaza Paseo 2000, Tijuana',
    direccion: 'Blvd. 2000 26135, Col. Ejido Francisco Villa, 22236 Tijuana, B.C.',
    foto: 'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/9e06cdd8787950de_puntoeste.jpg',
    mapSrc: 'https://maps.google.com/maps?q=32.492696,-116.852238&z=15&output=embed',
    mapsLink: 'https://www.google.com/maps?q=32.492696,-116.852238',
  },
  {
    nombre: 'Colectivo Fiu Fiu',
    tipo: 'Colectivo · Swaat Meet Siglo 21',
    referencia: 'Swaat Meet Siglo 21, Tijuana',
    direccion: 'Blvd. Gustavo Díaz Ordaz 15742, La Joya Este, 22115 Tijuana, B.C.',
    foto: 'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/8099fed5ef3ff55a_fiufiu.jpg',
    mapSrc: 'https://maps.google.com/maps?q=Blvd.+Gustavo+D%C3%ADaz+Ordaz+15742,+La+Joya+Este,+22115+Tijuana,+B.C.&z=15&output=embed',
    mapsLink: 'https://maps.app.goo.gl/FUVBEaxgqGNNcF74A',
  },
];

export default function Distributors() {
  return (
    <main style={{ background: '#0A0A0A', color: '#fff', fontFamily: 'Montserrat, sans-serif', paddingTop: '5rem' }}>

      {/* ===== HERO ===== */}
      <section
        style={{
          padding: '5rem 1.5rem 4rem',
          textAlign: 'center',
          borderBottom: '1px solid rgba(201,168,76,0.1)',
        }}
      >
        <p
          style={{
            color: GOLD,
            fontSize: '0.68rem',
            letterSpacing: '0.45em',
            textTransform: 'uppercase',
            marginBottom: '1rem',
          }}
        >
          Red Oficial
        </p>
        <h1
          style={{
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: 'clamp(2.2rem, 5vw, 3.5rem)',
            fontWeight: 300,
            color: '#fff',
            lineHeight: 1.15,
            marginBottom: '1rem',
          }}
        >
          Distribuidores &amp;{' '}
          <span style={{ color: GOLD, fontStyle: 'italic' }}>Sucursales</span>
        </h1>
        <p
          style={{
            color: 'rgba(255,255,255,0.45)',
            fontSize: '0.85rem',
            maxWidth: '36rem',
            margin: '0 auto',
            lineHeight: 1.75,
          }}
        >
          Conoce a nuestros distribuidores autorizados y los puntos de venta
          físicos donde puedes encontrar Aura Chocolate Supreme en Tijuana.
        </p>
      </section>

      {/* ===== DISTRIBUIDORES ===== */}
      <section style={{ padding: '5rem 1.5rem' }}>
        <div style={{ maxWidth: '64rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <p
              style={{
                color: GOLD,
                fontSize: '0.65rem',
                letterSpacing: '0.4em',
                textTransform: 'uppercase',
                marginBottom: '0.6rem',
              }}
            >
              Equipo
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(1.8rem, 3vw, 2.6rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Nuestros <span style={{ color: GOLD, fontStyle: 'italic' }}>Distribuidores</span>
            </h2>
          </div>

          {/* LinkedIn-style card */}
          <div
            style={{
              maxWidth: '480px',
              margin: '0 auto',
              background: '#111111',
              border: '1px solid rgba(201,168,76,0.2)',
              overflow: 'hidden',
            }}
          >
            {/* Card cover banner */}
            <div
              style={{
                height: '90px',
                background: 'linear-gradient(135deg, #1a1400 0%, #2e2000 50%, #1a1400 100%)',
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage:
                    'repeating-linear-gradient(45deg, rgba(201,168,76,0.04) 0px, rgba(201,168,76,0.04) 1px, transparent 1px, transparent 12px)',
                }}
              />
            </div>

            {/* Avatar */}
            <div style={{ padding: '0 2rem', position: 'relative' }}>
              <div
                style={{
                  width: '90px',
                  height: '90px',
                  borderRadius: '50%',
                  border: '3px solid #111111',
                  overflow: 'hidden',
                  marginTop: '-45px',
                  background: '#222',
                }}
              >
                <img
                  src={ANGEL_PHOTO}
                  alt="Angel"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }}
                />
              </div>
            </div>

            {/* Info */}
            <div style={{ padding: '0.75rem 2rem 2rem' }}>
              <h3
                style={{
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  color: '#fff',
                  marginBottom: '0.15rem',
                }}
              >
                Angel Meléndez
              </h3>
              <p
                style={{
                  fontSize: '0.78rem',
                  color: GOLD,
                  letterSpacing: '0.1em',
                  marginBottom: '0.4rem',
                }}
              >
                Distribuidor Autorizado · Tijuana, B.C.
              </p>
              <p
                style={{
                  fontSize: '0.75rem',
                  color: 'rgba(255,255,255,0.4)',
                  marginBottom: '1.5rem',
                  lineHeight: 1.6,
                }}
              >
                Representante oficial de Aura Chocolate Supreme en Tijuana. Ventas mayoreo y menudeo.
              </p>

              <div
                style={{
                  borderTop: '1px solid rgba(201,168,76,0.1)',
                  paddingTop: '1.25rem',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                  marginBottom: '1.75rem',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <MessageCircle size={14} style={{ color: GOLD, flexShrink: 0 }} />
                  <span style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)' }}>
                    +52 (664) 301 5306
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <Mail size={14} style={{ color: GOLD, flexShrink: 0 }} />
                  <span style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)' }}>
                    ventas@aurachocolates.com.mx
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <MapPin size={14} style={{ color: GOLD, flexShrink: 0 }} />
                  <span style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)' }}>
                    Tijuana, Baja California
                  </span>
                </div>
              </div>

              {/* Action buttons */}
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                <a
                  href="https://wa.me/526643015306"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.7rem 1.5rem',
                    background: GOLD,
                    color: '#000',
                    fontSize: '0.68rem',
                    letterSpacing: '0.2em',
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    textDecoration: 'none',
                    transition: 'opacity 0.3s ease',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.82')}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                >
                  <MessageCircle size={13} />
                  WhatsApp
                </a>
                <a
                  href="mailto:ventas@aurachocolates.com.mx"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.7rem 1.5rem',
                    border: '1px solid rgba(201,168,76,0.35)',
                    color: GOLD,
                    fontSize: '0.68rem',
                    letterSpacing: '0.2em',
                    textTransform: 'uppercase',
                    textDecoration: 'none',
                    transition: 'background 0.3s ease',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.07)')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                >
                  <Mail size={13} />
                  Correo
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SUCURSALES ===== */}
      <section
        style={{
          padding: '5rem 1.5rem 6rem',
          background: '#060606',
          borderTop: '1px solid rgba(201,168,76,0.1)',
        }}
      >
        <div style={{ maxWidth: '64rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <p
              style={{
                color: GOLD,
                fontSize: '0.65rem',
                letterSpacing: '0.4em',
                textTransform: 'uppercase',
                marginBottom: '0.6rem',
              }}
            >
              Tijuana, B.C.
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(1.8rem, 3vw, 2.6rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Puntos de <span style={{ color: GOLD, fontStyle: 'italic' }}>Venta</span>
            </h2>
            <p
              style={{
                color: 'rgba(255,255,255,0.4)',
                fontSize: '0.78rem',
                marginTop: '0.75rem',
              }}
            >
              Encuéntranos en estos puntos físicos de Tijuana.
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '2rem',
            }}
          >
            {sucursales.map((s, i) => (
              <div
                key={i}
                style={{
                  background: '#111111',
                  border: '1px solid rgba(201,168,76,0.15)',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {/* Photo — 55% of card */}
                <div style={{ position: 'relative', height: '280px', overflow: 'hidden', flexShrink: 0 }}>
                  <img
                    src={s.foto}
                    alt={s.nombre}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      display: 'block',
                      transition: 'transform 0.6s ease',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.04)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                  />
                  {/* Bottom gradient */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: '55%',
                      background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)',
                    }}
                  />
                  {/* Type badge — top left */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '1rem',
                      left: '1rem',
                      background: 'rgba(0,0,0,0.75)',
                      border: `1px solid ${GOLD}`,
                      padding: '0.3rem 0.75rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.4rem',
                      backdropFilter: 'blur(6px)',
                    }}
                  >
                    <Store size={10} style={{ color: GOLD }} />
                    <span style={{ color: GOLD, fontSize: '0.58rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
                      {s.tipo}
                    </span>
                  </div>
                  {/* Store name — bottom left over photo */}
                  <div style={{ position: 'absolute', bottom: '1rem', left: '1.25rem', right: '1.25rem' }}>
                    <h3
                      style={{
                        fontFamily: 'Cormorant Garamond, serif',
                        fontSize: '1.5rem',
                        fontWeight: 400,
                        color: '#fff',
                        margin: 0,
                        textShadow: '0 2px 8px rgba(0,0,0,0.7)',
                      }}
                    >
                      {s.nombre}
                    </h3>
                    <p style={{ fontSize: '0.68rem', color: GOLD, margin: '0.2rem 0 0', letterSpacing: '0.08em' }}>
                      {s.referencia}
                    </p>
                  </div>
                </div>

                {/* Info below photo */}
                <div style={{ padding: '1.25rem 1.5rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', flexGrow: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <MapPin size={13} style={{ color: 'rgba(201,168,76,0.5)', flexShrink: 0, marginTop: '3px' }} />
                    <p style={{ fontSize: '0.73rem', color: 'rgba(255,255,255,0.4)', lineHeight: 1.65, margin: 0 }}>
                      {s.direccion}
                    </p>
                  </div>
                  <a
                    href={s.mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.45rem',
                      fontSize: '0.65rem',
                      color: GOLD,
                      letterSpacing: '0.15em',
                      textTransform: 'uppercase',
                      textDecoration: 'none',
                      alignSelf: 'flex-start',
                      transition: 'opacity 0.3s ease',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.6')}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                  >
                    <MapPin size={11} />
                    Ver en Google Maps
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
}
